import { Component, ElementRef, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { AppService } from '../../app.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessSnackbarComponent } from '../../support/success-snackbar/success-snackbar.component';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { PaginationService } from '../../PaginationService';
import { messageService } from '../../message.service';
import { DynamicAuditTrailComponent } from '../../support/dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from '../../support/excel-pdf/excel-pdf.component';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { BusinessAreaService } from '../../business-area/business-area.service';
import { GridReorderComponent } from '../../grid-reorder/grid-reorder.component';
import { concatMap, from, of, tap } from 'rxjs';

@Component({
  selector: 'app-flexible-fields-setup',
  templateUrl: './flexible-fields-setup.component.html',
  styleUrls: ['./flexible-fields-setup.component.scss']
})

export class FlexibleFieldsSetupComponent implements OnInit {
  @Input() isReadOnly: boolean = false;
  isProcessing = true;
  flexibleFields: any = {};

  auditTrail: any = {};
  visibleAuditTrail: boolean = false;
  dateLovValuesDropdown: any = [];
  constructor(public dialog: MatDialog, public appService: AppService, public router: Router, private readonly snackBar: MatSnackBar,
    public paginationService: PaginationService, public message: messageService, private readonly elem: ElementRef, public businessAreaService: BusinessAreaService) {
  }

  mappingColumnsList: any = [];
  dropdownForModule: any = [];
  dropdownForGroup: any = [];
  dropdownForPopupGroup: any = [];
  dropdownForDataType: any = [];
  dropdownForFieldType: any = [];
  dropdownForDateFormat: any = [];
  dropdownForMappingColumn: any = [];
  dropdownForBusinessArea: any = [];

  moduleDropdown: any = [];
  groupDropdown: any = [];
  popupGroupDropdown: any = [];
  dataTypeDropdown: any = [];
  fieldTypeDropdown: any = [];
  dateFormatDropdown: any = [];
  mappingColumnDropdown: any = [];
  businessAreaDropdown: any = [];

  selectedModule: any = null;
  selectedGroup: any = null;
  selectedPopupGroup: any = null;
  selectedDataType: any = null;
  selectedFieldType: any = null;
  selectedDateFormat: any = null;
  selectedMappingColumn: any = null;
  selectedStatusFrom: any = null;
  selectedBusinessArea: any = [];
  oddModule: any = null;
  oddGroup: any = null;
  oddFieldType: any = null;
  oddDataType: any = null;
  oddDateFormat: any = null;
  oddMappingColumn: any = null;
  oddStatusFrom: any = null;

  ngOnInit(): void {

    this.isProcessing = true;
    this.dropdownForModule = JSON.parse(sessionStorage.getItem('dropDownForModules') ?? '{}');
    this.selectBoxForModule();

    this.appService.getNonOrgCodeListsByGroupName("FLEXIFIELD_FIELDTYPE").subscribe((data: any) => {
      this.dropdownForFieldType = [];
      for (const element of data) {
        if (element.codelistCode != "Document Repository") {
          this.dropdownForFieldType.push(element);
        }
      }
      this.selectBoxForFieldType();
    });

    this.appService.getNonOrgCodeListsByGroupName("DATE_LOV_VALUE").subscribe((data: any) => {
      for (const element of data) {
        this.dateLovValuesDropdown = this.dateLovValuesDropdown.concat({
          valueExp: element.codelistCode,
          displayExp: element.codelistName
        });
      }
    });

    this.appService.getNonOrgCodeListsByGroupName("FLEXIFIELD_DATATYPE").subscribe((data: any) => {
      this.dropdownForDataType = data;
      this.selectBoxForDataType();
    });

    this.appService.getNonOrgCodeListsByGroupName("FLEXIFIELD_DATEFORMAT").subscribe((data: any) => {
      this.dropdownForDateFormat = data;
      this.selectBoxForDateFormat();
    });

    if (this.appService.flexiFieldModule == 'Execution_Setup') {
      this.selectedModule = "BP"
      this.selectedModuleValueExp = "BP";
      this.selectedGroup = this.appService.executionSetupId
      this.selectedPopupGroup = this.appService.executionSetupId
      this.isProcessing = true;
      this.businessAreaService.getExecutiveSetupsList().subscribe((data: any) => {
        this.dropdownForGroup = data;
        this.selectBoxExecutionSetup();
        this.dropdownForPopupGroup = data;
        this.selectBoxForPopupExecutionSetup();
        this.isProcessing = false;
      })
      this.getCall();
    } else if (this.appService.flexiFieldModule == "qmsGroup") {
      for (const element of this.dropdownForModule) {
        if (element.codelistCode == this.appService.qmsGroupData.MODULE) {
          this.selectedModule = element.codelistCode
        }
      }

      this.selectedGroup = this.appService.qmsGroupData.GROUP_ID;
      this.selectedPopupGroup = this.appService.qmsGroupData.GROUP_ID;
      this.appService.getQmsGroupsByModule(this.appService.qmsGroupData.MODULE).subscribe((data: any) => {
        this.dropdownForGroup = data;
        this.selectBoxForGroup();
        this.dropdownForPopupGroup = data;
        this.selectBoxForPopupGroup();
        this.isProcessing = false;
      })
      this.getCall();
    }
    this.isProcessing = false;
  }

  selectBoxForModule() {
    this.moduleDropdown = [];
    this.moduleDropdown = [];
    this.moduleDropdown = this.dropdownForModule?.filter((item: any) => item.codelistName != 'Trainings').map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })) || [];


  }

  selectedModuleValueExp: string = '';

  focusSearch(value: any) {
    setTimeout(() => { let searchBox = document.getElementById(value); searchBox?.focus(); }, 0)
  }

  moduleSearchText: any;
  onModuleSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.isProcessing = true;
        this.selectedModuleValueExp = item.valueExp;
        this.selectedGroup = null;
        if (this.selectedModuleValueExp == "BP") {
          this.businessAreaService.getExecutiveSetupsList().subscribe((data: any) => {
            this.dropdownForGroup = data;
            this.selectBoxExecutionSetup();
            this.dropdownForPopupGroup = data;
            this.selectBoxForPopupExecutionSetup();
            this.isProcessing = false;
          })
        } else {
          this.appService.getQmsGroupsByModule(item.valueExp).subscribe((data: any) => {
            this.dropdownForGroup = data;
            this.selectBoxForGroup();
            this.dropdownForPopupGroup = data;
            this.selectBoxForPopupGroup();
            this.isProcessing = false;
          })
          this.appService.getQmsBusinessAreasByModule(item.valueExp).subscribe((data1: any) => {
            this.dropdownForBusinessArea = data1;
            this.selectBoxForBusinessArea();
            this.isProcessing = false;
          })
        }
        setTimeout(() => {
          this.getCall();
        }, 0);
      } else {
        this.isProcessing = false;
        this.grid = [];
        this.selectedGroup = null;
      }
      this.isProcessing = false;
    }
    this.isProcessing = false;
  }

  selectBoxExecutionSetup() {
    this.groupDropdown = [];
    this.groupDropdown = this.dropdownForGroup?.map((group: any) => ({
      valueExp: group.setupId,
      displayExp: group.setupName
    })) || []
  }

  selectBoxForGroup() {
    this.groupDropdown = [];
    this.groupDropdown = this.dropdownForGroup?.map((group: any) => ({
      valueExp: group.groupId,
      displayExp: group.groupName
    })) || []
  }

  groupSearchText: any;

  onGroupSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.getCall();
    }
  }

  selectBoxForPopupGroup() {
    this.popupGroupDropdown = [];
    this.popupGroupDropdown = this.dropdownForPopupGroup?.map((group: any) => ({
      valueExp: group.groupId,
      displayExp: group.groupName
    })) || []
  }

  selectBoxForPopupExecutionSetup() {
    this.popupGroupDropdown = [];
    this.popupGroupDropdown = this.dropdownForPopupGroup?.map((group: any) => ({
      valueExp: group.setupId,
      displayExp: group.setupName
    })) || []
  }

  groupPopupSearchText: any;

  onPopupGroupSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => { this.handleDropDownValidation('popup-group-name', this.selectedPopupGroup) })
    }
  }

  selectBoxForFieldType() {
    this.fieldTypeDropdown = [];
    this.fieldTypeDropdown = this.dropdownForFieldType?.filter((x: any) => x.codelistName != 'Date Field').map((type: any) => ({
      valueExp: type.codelistCode,
      displayExp: type.codelistName
    }))
  }

  fieldTypeSearchText: any;
  onFieldTypeSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.selectedDataType = null;
      setTimeout(() => { this.handleDropDownValidation('field-type', this.selectedFieldType); this.selectBoxForDataType(); })
    }
  }

  selectBoxForDataType() {
    this.dataTypeDropdown = [];

    let x: any[] = this.dropdownForDataType;

    if (this.selectedFieldType == 'Multiselect Drop Down') {
      x = x?.filter((y: any) => y.codelistCode.toLowerCase() != 'number' && y.codelistCode.toLowerCase() != 'date' && y.codelistCode.toLowerCase() != 'datetime');
    } else if (this.selectedFieldType == 'Text Field' || !this.selectedFieldType) {
      x = this.dropdownForDataType;
    } else {
      x = x?.filter((y: any) => y.codelistCode.toLowerCase() != 'date' && y.codelistCode.toLowerCase() != 'datetime');
    }

    this.dataTypeDropdown = x?.map((type: any) => ({
      valueExp: type.codelistCode,
      displayExp: type.codelistName
    }))
  }

  selectedDataTypeValueExp: string = '';
  dataTypeSearchText: any;
  onDataTypeSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item) {
        this.selectedDataTypeValueExp = item.valueExp;
        this.callColumnFunc(this.selectedDataTypeValueExp);
      } else {
        this.selectedMappingColumn = this.dropdownForMappingColumn = this.mappingColumnDropdown = [];
      }
      setTimeout(() => { this.handleDropDownValidation('data-type', this.selectedDataType) })
    }
  }

  selectBoxForDateFormat() {
    this.dateFormatDropdown = [];
    this.dateFormatDropdown = this.dropdownForDateFormat?.map((type: any) => ({
      valueExp: type.codelistCode,
      displayExp: type.codelistName
    }))
  }

  dateTypeSearchText: any;
  onDateFormatSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => { this.handleDropDownValidation('date-format', this.selectedDateFormat) })
    }
  }

  selectBoxForMappingColumn() {
    this.mappingColumnDropdown = [];
    this.mappingColumnDropdown = this.dropdownForMappingColumn?.map((type: any) => ({
      valueExp: type,
      displayExp: type
    }))
  }

  mappingColumnSearchText: any;
  statusFromTxt: any;
  onMappingColumnSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => { this.handleDropDownValidation('mapping-column', this.selectedMappingColumn) })
    }
  }

  selectBoxForBusinessArea() {
    this.businessAreaDropdown = [];
    this.businessAreaDropdown = this.dropdownForBusinessArea?.map((area: any) => ({
      valueExp: area.taskRequestedAt,
      displayExp: area.taskRequestedAt
    })) || []
  }

  businessAreaChange(event: MatSlideToggleChange) {
    this.selectedBusinessArea = [];
  }
  @ViewChild('allowedBusinessArea') allowedBusinessArea: MatSelect;


  isAllowedBusinessAreaSelected = false;

  toggleAllSelection(value: any) {
    if (value == 'allowedBusinessArea') {
      if (this.isAllowedBusinessAreaSelected) this.allowedBusinessArea.options.forEach((item: MatOption) => item.select());
      else this.allowedBusinessArea.options.forEach((item: MatOption) => item.deselect());
    }
  }

  allowedBusinessAreaText: any;
  onAllowedBusinessAreaSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => { this.isAllowedBusinessAreaSelected = this.businessAreaDropdown.length == this.selectedBusinessArea.length; })
    }
  }

  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;

  addAndEditPopupConfig = {
    width: '80%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  deletePopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  multiSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: true,
    allowSearchFilter: true,
    singleSelection: false,
  };

  popupTitle: string = "";
  visibleAddButton: boolean = false;
  visibleEditButton: boolean = false;
  dropdownFortaskStatusSetup: any;
  taskStatusSetupDropdown: any = [];
  selectedDays: any;
  selectedLovValue: any;
  openAddPopup() {
    if (this.selectedModule) {
      this.isProcessing = true;
      this.popupTitle = "Create Flexifield";
      this.selectedUserCriteria = 'Create New';
      this.visibleAddButton = true;
      this.visibleEditButton = false;
      this.flexibleFields = {};
      this.selectedLovValue = null;
      this.selectedDays = null;
      this.selectedMappingColumn = this.dropdownForMappingColumn = this.mappingColumnDropdown = [];
      [this.selectedPopupGroup, this.selectedFieldType, this.selectedDataType, this.selectedDateFormat, this.selectedMappingColumn, this.selectedBusinessArea, this.selectedStatusFrom] =
        [null, null, null, null, null, [], null];
      this.dropdownFortaskStatusSetup = [];
      this.flexibleFields.isActive = true;
      if (this.selectedGroup) this.selectedPopupGroup = this.selectedGroup;
      this.mappingColumnsList = [];
      for (const element of this.grid) {
        this.mappingColumnsList.push(element.MAPPING_COLUMN);
      }
      this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
      this.appService.getQmsBusinessAreasByModule(this.selectedModule).subscribe((data1: any) => {
        this.dropdownForBusinessArea = data1;
        this.selectBoxForBusinessArea();
        this.isProcessing = false;
        setTimeout(() => { this.isAllowedBusinessAreaSelected = this.businessAreaDropdown.length == this.selectedBusinessArea.length; });
      });
      this.appService.gettaskStatusSetupListByModule(this.selectedModule).subscribe((data1: any) => {

        this.dropdownFortaskStatusSetup = data1;
        this.selectBoxFortaskStatusSetup();
        this.isProcessing = false;
      })

    } else {
      this.showSnackBar('Please select Module!', 'E');
    }
  }

  selectBoxFortaskStatusSetup() {

    this.taskStatusSetupDropdown = [];
    this.taskStatusSetupDropdown = this.dropdownFortaskStatusSetup?.map((area: any) => ({
      valueExp: area.fromStatus,
      displayExp: area.fromStatus
    })) || [];
    this.taskStatusSetupDropdown = this.taskStatusSetupDropdown.filter((item: { displayExp: string; }) => (item.displayExp !== 'Scheduled'));
    this.taskStatusSetupDropdown = this.taskStatusSetupDropdown.filter((item: { displayExp: string; }) => (item.displayExp !== 'Pending Revoke Approval'));
    this.taskStatusSetupDropdown = this.taskStatusSetupDropdown.filter((item: { displayExp: string; }) => (item.displayExp !== 'Pending Delete Approval'));
    this.taskStatusSetupDropdown = this.taskStatusSetupDropdown.filter((item: { displayExp: string; }) => (item.displayExp !== 'Obsoleted'));
    this.taskStatusSetupDropdown = this.taskStatusSetupDropdown.filter((item: { displayExp: string; }) => (item.displayExp !== 'Closed'));
    this.taskStatusSetupDropdown = this.taskStatusSetupDropdown.filter((item: { displayExp: string; }) => (item.displayExp !== 'Revoked'));
    this.taskStatusSetupDropdown = this.taskStatusSetupDropdown.filter((item: { displayExp: string; }) => (item.displayExp !== 'Evaluation Rejected-Rejected'));
    this.taskStatusSetupDropdown = this.taskStatusSetupDropdown.filter((item: { displayExp: string; }) => (item.displayExp !== 'Complaint Rejected-Closed'));
    this.taskStatusSetupDropdown = this.taskStatusSetupDropdown.filter((item: { displayExp: string; }) => (item.displayExp !== 'Draft(Schedule)'));
    this.taskStatusSetupDropdown = this.taskStatusSetupDropdown.filter((item: { displayExp: string; }) => (item.displayExp !== 'Pending Schedule Approval'));
    this.taskStatusSetupDropdown = this.taskStatusSetupDropdown.filter((item: { displayExp: string; }) => (item.displayExp !== 'Schedule Rejected'));
    this.taskStatusSetupDropdown = this.taskStatusSetupDropdown.filter((item: { displayExp: string; }) => (item.displayExp !== 'Re-Draft(Schedule)'));
    this.taskStatusSetupDropdown = this.taskStatusSetupDropdown.filter((item: { displayExp: string; }) => (item.displayExp !== 'Schedule Deleted'));
    this.taskStatusSetupDropdown = this.taskStatusSetupDropdown.filter((item: { displayExp: string; }) => (item.displayExp !== 'Schedule Cancelled'));
    this.taskStatusSetupDropdown = this.taskStatusSetupDropdown.filter((item: { displayExp: string; }) => (item.displayExp !== 'Schedule locked/New plans not allowed'));
    this.taskStatusSetupDropdown = this.taskStatusSetupDropdown.filter((item: { displayExp: string; }) => (item.displayExp !== 'Plan Deleted'));
    this.taskStatusSetupDropdown = this.taskStatusSetupDropdown.filter((item: { displayExp: string; }) => (item.displayExp !== 'Plan Cancelled'));
    this.taskStatusSetupDropdown = this.taskStatusSetupDropdown.filter((item: { displayExp: string; }) => (item.displayExp !== 'Reopened'));
    this.taskStatusSetupDropdown = this.taskStatusSetupDropdown.filter((item: { displayExp: string; }) => (item.displayExp !== 'Approval Completed'));
    this.taskStatusSetupDropdown = this.taskStatusSetupDropdown.filter((item: { displayExp: string; }) => (item.displayExp !== 'Review Completed'));
    this.taskStatusSetupDropdown = this.taskStatusSetupDropdown.filter((item: { displayExp: string; }) => (item.displayExp !== 'Closure Approval Completed'));
    this.taskStatusSetupDropdown = this.taskStatusSetupDropdown.filter((item: { displayExp: string; }) => (item.displayExp !== 'Closure Review Completed'));
    this.taskStatusSetupDropdown = this.taskStatusSetupDropdown.filter((item: { displayExp: string; }) => (item.displayExp !== 'Deleted'));
  };

  editingFieldId: any;
  showDateFormatField = false;
  openEditPopup(editingField: any) {
    this.isProcessing = true;
    this.popupTitle = "Update Flexifield";
    this.selectedUserCriteria = 'Update';
    this.visibleAddButton = false;
    this.visibleEditButton = true;
    this.editingFieldId = editingField.FIELD_ID;
    this.dropdownFortaskStatusSetup = [];
    this.selectedStatusFrom = null;
    this.appService.getFlexifieldSetupById(this.editingFieldId).subscribe((flexibleField: any) => {
      this.taskStatusSetupDropdown = [];

      if (flexibleField.module) {
        const matchingModule = this.dropdownForModule?.find((item: any) => item.codelistCode == flexibleField.module);
        if (!matchingModule) {
          this.oddModule = flexibleField.module;
          this.moduleDropdown.push({
            valueExp: flexibleField.module,
            displayExp: flexibleField.module
          })
        }
        this.selectedModule = flexibleField.module
        this.selectedModuleValueExp = matchingModule.codelistCode;

        if (this.selectedModuleValueExp == 'BP') {
          this.businessAreaService.getExecutiveSetupsList().subscribe((group: any) => {
            this.dropdownForPopupGroup = group;
            this.selectBoxForPopupExecutionSetup();
            const matchingPopupGroup = this.dropdownForPopupGroup?.find((item: any) => item.setupId == Number.parseInt(flexibleField.groupOrFolderIdList));
            if (!matchingPopupGroup) {
              this.oddGroup = Number.parseInt(flexibleField.groupOrFolderIdList);
              this.popupGroupDropdown.push({
                valueExp: Number.parseInt(flexibleField.groupOrFolderIdList),
                displayExp: Number.parseInt(flexibleField.groupOrFolderIdList)
              })
            }
            this.selectedPopupGroup = Number.parseInt(flexibleField.groupOrFolderIdList);
          })
          this.appService.getQmsBusinessAreasByModule(this.selectedModule).subscribe((data1: any) => {
            this.dropdownForBusinessArea = data1;
            this.selectBoxForBusinessArea();
            this.isProcessing = false;
          })
        }
        else {
          this.appService.getQmsGroupsByModule(this.selectedModule).subscribe((group: any) => {
            this.dropdownForPopupGroup = group;
            this.selectBoxForPopupGroup();
            const matchingPopupGroup = this.dropdownForPopupGroup?.find((item: any) => item.groupId == Number.parseInt(flexibleField.groupOrFolderIdList));
            if (!matchingPopupGroup) {
              this.oddGroup = Number.parseInt(flexibleField.groupOrFolderIdList);
              this.popupGroupDropdown.push({
                valueExp: Number.parseInt(flexibleField.groupOrFolderIdList),
                displayExp: Number.parseInt(flexibleField.groupOrFolderIdList)
              })
            }
            this.selectedPopupGroup = Number.parseInt(flexibleField.groupOrFolderIdList);
          })
        }
      }


      if (flexibleField.fieldType) {
        const matchingfieldType = this.dropdownForFieldType?.find((item: any) => item.codelistCode == flexibleField.fieldType);
        if (!matchingfieldType) {
          this.oddFieldType = flexibleField.fieldType;
          this.fieldTypeDropdown.push({
            valueExp: flexibleField.fieldType,
            displayExp: flexibleField.fieldType
          })
        }
        this.selectedFieldType = flexibleField.fieldType
        this.selectedFieldType == 'Multiselect Drop Down' && (this.dataTypeDropdown = this.dataTypeDropdown?.filter((type: any) => type.valueExp.toLowerCase() != 'number'))
      }
      this.mappingColumnsList = [];
      for (const element of this.grid) {
        if (flexibleField.fieldId != element.FIELD_ID) {
          this.mappingColumnsList.push(element.MAPPING_COLUMN);
        }

      }

      if (flexibleField.fieldDatatype) {
        if (flexibleField.fieldDatatype == 'Date' || flexibleField.fieldDatatype == 'Datetime') {
          this.showDateFormatField = true;
          if (flexibleField.fieldLovValues) {
            if (flexibleField.fieldLovValues.includes("+")) {
              let data = flexibleField.fieldLovValues.split("+");
              this.selectedDays = Number.parseInt(data[1]);
              data[1] = "n";
              this.selectedLovValue = data.join("+ ");
            }
            if (flexibleField.fieldLovValues.includes("-")) {
              let data = flexibleField.fieldLovValues.split("-");
              this.selectedDays = Number.parseInt(data[1]);
              data[1] = "n";
              this.selectedLovValue = data.join("- ");
            }
            if (!flexibleField.fieldLovValues.includes("+") && !flexibleField.fieldLovValues.includes("-")) {
              this.selectedLovValue = flexibleField.fieldLovValues;
            }
          } else {
            this.selectedLovValue = null;
          }
        } else {
          this.showDateFormatField = false;
          flexibleField.dateFormat = null;
        }
        const matchingDataType = this.dropdownForDataType?.find((item: any) => item.codelistCode == flexibleField.fieldDatatype);
        if (!matchingDataType) {
          this.oddDataType = flexibleField.fieldDatatype;
          this.dataTypeDropdown.push({
            valueExp: flexibleField.fieldDatatype,
            displayExp: flexibleField.fieldDatatype
          })
        }
        this.selectedDataType = flexibleField.fieldDatatype
        this.selectedDataTypeValueExp = flexibleField.fieldDatatype
        setTimeout(() => { this.callColumnFunc(flexibleField.fieldDatatype) }, 1200);


      }

      if (flexibleField.fieldDateFormat) {
        const matchingDateFormat = this.dropdownForDateFormat?.find((item: any) => item.codelistCode == flexibleField.fieldDateFormat);
        if (!matchingDateFormat) {
          this.oddDateFormat = flexibleField.fieldDateFormat;
          this.dateFormatDropdown.push({
            valueExp: flexibleField.fieldDateFormat,
            displayExp: flexibleField.fieldDateFormat
          })
        }
        this.selectedDateFormat = flexibleField.fieldDateFormat
      }

      setTimeout(() => {


        if (flexibleField.mappingColumn) {
          this.selectBoxForMappingColumn();
          const matchingMappingColumn = this.dropdownForMappingColumn?.find((item: any) => item == flexibleField.mappingColumn);
          if (!matchingMappingColumn) {
            this.mappingColumnDropdown.push({
              valueExp: flexibleField.mappingColumn,
              displayExp: flexibleField.mappingColumn
            })
          }
          this.selectedMappingColumn = flexibleField.mappingColumn
        }
      }, 1200);
      this.appService.gettaskStatusSetupListByModule(this.selectedModule).subscribe((data1: any) => {
        this.dropdownFortaskStatusSetup = data1;
        this.selectBoxFortaskStatusSetup();
        if (flexibleField.appearFromStatus) {
          const matchingappearFromStatusColumn = this.taskStatusSetupDropdown?.find((item: any) => item.valueExp == flexibleField.appearFromStatus);
          if (!matchingappearFromStatusColumn) {

            this.taskStatusSetupDropdown.push({
              valueExp: flexibleField.appearFromStatus,
              displayExp: flexibleField.appearFromStatus
            })
          }
          this.selectedStatusFrom = flexibleField.appearFromStatus;
        }
        this.isProcessing = false;
      })
      if (flexibleField.allowedBusinessAreas) {
        this.selectedBusinessArea = flexibleField.allowedBusinessAreas.split(',');
        setTimeout(() => {
          this.isAllowedBusinessAreaSelected = this.businessAreaDropdown.length == this.selectedBusinessArea.length;
          flexibleField.allowedBusinessAreas.split(',').length == this.dropdownForBusinessArea.length && this.allowedBusinessArea.options.forEach((item: MatOption) => item.select());
        })

      }

      flexibleField.isMandatory = flexibleField.isMandatory == "Y";
      flexibleField.isActive = flexibleField.isActive == "Y";
      flexibleField.applicableForSpecificBusinessArea = flexibleField.applicableForSpecificBusinessArea == "Y";
      flexibleField.updateReason = '';

      this.flexibleFields = flexibleField;
      this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
      this.isProcessing = false;
    })


  }

  deleteReason: any = null;
  deletingFieldId: number;
  openDeletePopup(deletingField: any) {
    this.flexibleFields.deleteReason = '';
    this.popupTitle = "Delete Flexifield";
    this.deletingFieldId = deletingField.FIELD_ID;
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  focusEmpty() {
    console.log();
  }

  callColumnFunc(dataType: any) {
    this.isProcessing = true;
    let dataTye = dataType;
    if (dataType == "Char") {
      dataTye = "VARCHAR2";
    } else if (dataType == "Number") {
      dataTye = "NUMBER";
    } else if (dataType == "Date" || dataType == "Datetime") {
      dataTye = "DATE";
    }
    this.appService.getDataTypeForMappingColumn(dataTye).subscribe((data: any) => {
      this.dropdownForMappingColumn = data;
      this.selectBoxForMappingColumn();
      this.isProcessing = false;
    })
  }

  validateNumberFields(event: KeyboardEvent) {
    const forbiddenKeys = ['E', 'e', '-', '*', '+', '.'];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  handleDropDownValidation(fieldId: string, selectedItems: any[]) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    field.style.color = selectedItems.length === 0 && field ? 'red' : '';
  }

  onNgModelChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    field.style.color = items ? '#005c8a' : 'red';
  }

  fieldValidation(elementIds: string[]) {
    elementIds.forEach((elementId) => {
      const element = document.getElementById(elementId) as HTMLInputElement;
      element.style.color = 'red';
    });
  }

  addAndEditFunction(fieldData: any) {
    this.isProcessing = true;
    const validations = [
      { condition: this.selectedModule != 'DOCS' && !this.selectedPopupGroup, id: 'popup-group-name' },
      { condition: !this.flexibleFields.fieldName, id: 'field-name' },
      { condition: !this.selectedFieldType, id: 'field-type' },
      { condition: !this.selectedDataType, id: 'data-type' },
      { condition: !this.selectedMappingColumn, id: 'mapping-column' },
      { condition: fieldData.applicableForSpecificBusinessArea && !this.selectedBusinessArea, id: 'business-area' },
      { condition: !fieldData.updateReason && this.visibleEditButton, id: 'update-reason' }
    ]

    const invalidIds = validations.filter((validation) => validation.condition).map((validation) => validation.id);

    if (invalidIds.length > 0) {
      this.fieldValidation(invalidIds);
      this.showSnackBar('Please enter mandatory fields', 'E');
      this.isProcessing = false;
    } else {
      this.prepareObj(fieldData);
    }
  }

  prepareObj(fieldData: any) {

    let specificBusinessArea = 'N';
    let businessAreasList = null;

    if (this.selectedModuleValueExp !== 'AU' && this.selectedModuleValueExp !== 'CC') {
      specificBusinessArea = fieldData.applicableForSpecificBusinessArea ? "Y" : "N";
      businessAreasList = fieldData.applicableForSpecificBusinessArea ? this.selectedBusinessArea?.join(',') : null;
    }
    let flexibleFieldsObj = {

      module: this.selectedModule,
      groupOrFolderIdList: this.selectedModule === 'DOCS' ? null : (this.selectedPopupGroup ?? null),
      fieldSeq: this.visibleAddButton ? 1 : fieldData.fieldSeq,
      fieldName: fieldData.fieldName,
      instructions: fieldData.instructions,
      fieldType: this.selectedFieldType ?? null,
      fieldDatatype: this.selectedDataType ?? null,
      fieldDateFormat: this.selectedDateFormat ?? null,
      fieldWidth: fieldData.fieldWidth,
      fieldHeight: fieldData.fieldHeight,
      fieldDefaultValue: fieldData.fieldDefaultValue,
      fieldLovValues: fieldData.fieldLovValues,
      fieldLovQuery: fieldData.fieldLovQuery,
      mappingColumn: this.selectedMappingColumn ?? null,
      isMandatory: fieldData.isMandatory ? "Y" : "N",
      applicableForSpecificBusinessArea: specificBusinessArea,
      allowedBusinessAreas: businessAreasList,
      isActive: fieldData.isActive ? "Y" : "N",
      appearFromStatus: this.selectedStatusFrom,
      ...this.visibleEditButton && { updateReason: fieldData.updateReason }
    }

    this.executeAddEdit(flexibleFieldsObj);
  }

  executeAddEdit(data: {}) {
    if (this.visibleAddButton) {
      this.appService.createFlexifieldSetup(data).subscribe({
        next: (Response: any) => {
          if (Response.resultType == "S") {
            this.getCall();
            this.visibleAddAndEditPopup.close();
            this.showSnackBar(Response.result, Response.resultType);
          } else {
            this.isProcessing = false;
            this.showSnackBar(Response.result, Response.resultType);
          }
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    } else {
      const modifiedObj = {
        fieldId: this.editingFieldId,
        ...data,
      }
      this.appService.updateFlexifieldSetup(modifiedObj).subscribe({
        next: (Response: any) => {
          if (Response.resultType == "S") {
            this.getCall();
            this.visibleAddAndEditPopup.close();
            this.showSnackBar(Response.result, Response.resultType);
          } else {
            this.isProcessing = false;
            this.showSnackBar(Response.result, Response.resultType);
          }
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  cancelAddAndEditFunction() {
    if (this.isCopyingFlexibleFields) { this.isCopyingFlexibleFields = false; this.getCall(); }
    this.visibleAddAndEditPopup.close();
  }

  deleteFunction(flexible: any) {
    if (this.flexibleFields.deleteReason) {
      this.isProcessing = true;

      const data = {

        fieldId: this.deletingFieldId,
        deleteReason: flexible.deleteReason
      }

      this.appService.deleteFlexifieldSetup(data).subscribe({
        next: (Response: any) => {
          if (Response.resultType == "S") {
            this.getCall();
            this.visibleDeletePopup.close();
            this.showSnackBar(Response.result, Response.resultType);
          } else {
            this.isProcessing = false;
            this.showSnackBar(Response.result, Response.resultType);
          }
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    } else {
      const field = document.getElementById('delete-reason') as HTMLInputElement;
      field.style.color = 'red';
    }
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }

  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel || this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }

  searchText: any;
  searchValue: any;
  _temp: any = {};
  columnLists: any = {};
  grid: any = [];
  gridTemp: any;
  makeStickyColumns: any;
  dataTypeList: any = [];
  visibleDataGrid: boolean = false;
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  pager: any = {};
  pagedItems: any[];
  error = '';
getCall() {
    this.isProcessing = true;
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);

    const data = {
      gridName: "FLEXIFIELDS",
    };

    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {
        response.orderByClause = response.orderByClause ? response.orderByClause : "";
        this.makeStickyColumns = response.fixedFieldCnt;

        const data1: any = {
          gridName: "FLEXIFIELDS",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || "",
          module: this.isCopyingFlexibleFields ? (this.selectedSourceModule ?? null) : (this.selectedModule ?? null),
          groupId: this.selectedGroup?.toString() ?? null,
        };

        this.reportObj = { ...data1, ...data };
        this.auditTrail.secondary_obj = data1;

        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.grid = response1;
            this.visibleAuditTrail = false;

            const rawColumns = data1.columnsList.split(",");
            const rawLabels = data1.fieldLabelsList.split(",");
            const rawSizes = data1.fieldSizeList.split(",");
            const invisibleCols = data1.invisibleColumn.split(",").map((col: string) => col.trim());

            this.columnLists.columnsListarray = [];
            this.columnLists.fieldColumnarray = [];
            this.columnLists.fieldSizeListArray = [];
            this.columnLists.invisibleColumnarray = invisibleCols;

            for (let i = 0; i < rawColumns.length; i++) {
              const colName = rawColumns[i].trim();
              const labelName = rawLabels[i]?.trim() || "";
              const size = rawSizes[i]?.trim() || "150";

              if (invisibleCols.includes(colName)) {
                continue;
              }

              if (this.appService.flexiFieldModule === 'Execution_Setup' && labelName === "Group Name") {
                continue;
              }

              this.columnLists.columnsListarray.push(colName);
              this.columnLists.fieldSizeListArray.push(size + 'px');
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": labelName,
                "width": size + 'px'
              });
            }

            const tableData = {
              tablename: data1.tableOrViewName
            };

            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;

              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                const colName = this.columnLists.columnsListarray[m];
                let fieldType = "textbox";

                const matchedType = this.dataTypeList.find((element: any) => element.columnName === colName);
                if (matchedType) {
                  fieldType = matchedType.fieldType;
                }

                this.columnLists.columnsListarray1.push({
                  columnsListarray: colName,
                  dataType: fieldType,
                  width: this.columnLists.fieldSizeListArray[m] 
                });
              }

              for (const rowData of this.grid) {
                for (const element of this.dataTypeList) {
                  if (element.fieldType === 'CHECKBOX') {
                    rowData[element.columnName] = rowData[element.columnName] === 'Y';
                  }
                }
              }

              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.pager.totalPages = undefined;
              this.setPage(1, 0);
              this.labelcall();
            });

            this.message.gridList = this.grid;
            this.collectionSize = this.grid.length;
            this.totalPages = Math.ceil(this.grid.length / this.itemsPerPage);
            this.isProcessing = false;
          },
          error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      },
      error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  label: any = [];
  dynamicLabel: any = null;
  labelcall() {
    this.isProcessing = true;
    let data = {
      tableName: this.reportObj.tableOrViewName,
      moduleName: null,
      gridName: this.reportObj.gridName,
      groupId: 0
    };
    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (data: any) => {
        this.label = data;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = user.changedFieldName;
          return acc;
        }, {});
        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
      }
    });
  }

  setPage(page: number, targetPage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.grid.length, page, this.perPage, targetPage);
    this.pagedItems = this.grid.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  setPagedOrSearch(page: number, targetPage: number) {
    if (Number.isNaN(page)) {
      page = 1;
    }

    if (this.gridTemp.length > 0) {
      this.pager = this.paginationService.getPager(this.gridTemp.length, page, this.perPage, targetPage);
      this.pagedItems = this.gridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.grid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.grid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }

  searchValue2: any;
  applyFilter2(event: Event) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.gridTemp = this.grid;
      this.pager = this.paginationService.getPager(this.gridTemp.length, 1, this.perPage, 0);
      this.pagedItems = this.gridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      if (this.grid == undefined) {
        return this.grid;
      }
      if (!this.grid.length) {
        return this.grid;
      }
      if (filter) {
        this.gridTemp = this.grid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase().includes(filter);
        });
      } else {
        this.gridTemp = this.grid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase();
        });
      }
      this.setPagedOrSearch(1, 0);
    }
  }

  sortedColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.grid.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA < valueB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA > valueB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  counts: any;
  cssFunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })

    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          column.style.background = 'white';

          if (index2 > 1) {
            colWidth += 200;
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  }

  onClick(event: any) {

  }

  parentCheckBox: boolean = false;
  childCheckBox: boolean = false;
  onParentChanged(e: any) {
    if (e.target.checked) {
      if (this.isCopyingFlexibleFields) { this.copyingFieldData = this.pagedItems.length == 10 ? this.grid : this.pagedItems; }
      for (const element of this.grid) {
        element.childCheckBox = true;
      }
    } else {
      if (this.isCopyingFlexibleFields) { this.copyingFieldData = [] }
      for (const element of this.grid) {
        element.childCheckBox = false;
      }
    }
  }

  onChildChanged(e: any, list: any, idx: any) {
    if (e.target.checked) {
      list.childCheckBox = true;
      this.onChildChecked(list);
    } else {
      this.parentCheckBox = list.childCheckBox = false;
      this.isCopyingFlexibleFields && this.onChildUnchecked(list);
    }
  }

  onChildChecked(checked: any) {
    if (this.isCopyingFlexibleFields) {
      if (!this.copyingFieldData?.some((copied: any) => copied.FIELD_ID === checked.FIELD_ID)) {
        this.copyingFieldData.push(checked);
      }

      if (this.grid.every((r: any) => r.childCheckBox)) {
        this.parentCheckBox = true;
      }
    } else {
      this.grid.every((item: any) => { if (item.childCheckBox && checked.FIELD_ID != item.FIELD_ID) { item.childCheckBox = false; } return true; })
    }
  }

  onChildUnchecked(unchecked: any) {
    const removal = this.copyingFieldData?.findIndex((copied: any) => copied.FIELD_ID == unchecked.FIELD_ID);
    if (removal > -1) this.copyingFieldData?.splice(removal, 1);
  }

  refreshGridData() {
    this.getCall();
  }

  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;

  openAuditTrail(viewType: any, flexibleFields: any) {
    this.auditTrail.refNo = viewType == 'overAll' ? null : flexibleFields.FIELD_ID;
    this.auditTrail.gridName = 'FLEXIFIELDS';
    this.auditTrail.report_And_Popup_Name = 'Flexible Fields Audit Trail';
    this.dynamicAuditTrailComponent.triggerTrail(flexibleFields);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = this.reportObj;
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = 'Flexible Fields Report';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.reportObj.gridName, this.reportObj.tableOrViewName, null, 0)
  }

  onChildValueEmitted() {
    this.getCall();
  };

  lovValueSearchText: string = '';
  onNumberOfDaysEntered(days: any) {
    if (this.selectedLovValue.includes("+")) {
      let data = this.selectedLovValue.split("+")
      data[1] = days;
      this.flexibleFields.fieldLovValues = data.join("+ ");
    }
    if (this.selectedLovValue.includes("-")) {
      let data = this.selectedLovValue.split("-")
      data[1] = days;
      this.flexibleFields.fieldLovValues = data.join("- ");
    }
  }

  lovValuesSelect(event: any, data: any) {
    if (event.isUserInput) {
      this.flexibleFields.fieldLovValues = data.valueExp;
    }
  }

  selectedUserCriteria: any;
  searchCriteriaOptions: any = ['Create New', 'Copy'];
  copyingFieldData: any = [];

  @ViewChild('copyResultPopup', { static: true }) copyResultPopup: TemplateRef<any>;
  visibleCopyResultPopup: MatDialogRef<TemplateRef<any>>;

  copyResultPopupConfig = {
    width: '75%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  isCopyingFlexibleFields: boolean = false;
  onSearchCriteriaChanged(criteria: any) {

    if (criteria == 'Create New') {
      [
        this.selectedPopupGroup,
        this.selectedFieldType,
        this.selectedDataType,
        this.selectedDateFormat,
        this.selectedMappingColumn,
        this.selectedStatusFrom,
        this.selectedDays,
        this.selectedLovValue,
        this.visibleEditButton,
        this.visibleAddButton,
        this.mappingColumnsList,
        this.dropdownFortaskStatusSetup,
        this.selectedBusinessArea,
        this.flexibleFields,
        this.isCopyingFlexibleFields
      ] = [null, null, null, null, null, null, null, null, false, true, [], [], [], {}, false];

      if (this.selectedGroup) this.selectedPopupGroup = this.selectedGroup;

      for (const element of this.grid) {
        this.mappingColumnsList.push(element.MAPPING_COLUMN);
      }

      this.appService.getQmsBusinessAreasByModule(this.selectedModule).subscribe((data1: any) => {
        this.dropdownForBusinessArea = data1;
        this.selectBoxForBusinessArea();
        this.isProcessing = false;
        setTimeout(() => { this.isAllowedBusinessAreaSelected = this.businessAreaDropdown.length == this.selectedBusinessArea.length; });
      });

      this.appService.gettaskStatusSetupListByModule(this.selectedModule).subscribe((data1: any) => {
        this.dropdownFortaskStatusSetup = data1;
        this.selectBoxFortaskStatusSetup();
        this.isProcessing = false;
      });
    } else {
      [
        this.pagedItems,
        this.grid,
        this.copyingFieldData,
        this.responses,
        this.selectedSourceModule,
        this.selectedTargetModule,
        this.selectedPopupGroup,
        this.parentCheckBox,
        this.isCopyingFlexibleFields
      ] = [[], [], [], [], null, null, null, false, true];
    }
  }

  selectedSourceModule: any;
  selectedTargetModule: any;
  moduleSearchTxt: any;
  selectedTargetModuleValueExp: any
  onSourceModuleSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item) {
        this.selectedGroup = null;
        this.getCall();
      } else {
        this.grid = [];
        this.selectedGroup = null;
      }
    }
  }

  onTargetModuleSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item) {
        this.selectedTargetModuleValueExp = item.valueExp;
        if (item.valueExp == "BP") {
          this.businessAreaService.getExecutiveSetupsList().subscribe((data: any) => {
            this.dropdownForGroup = data;
            this.selectBoxExecutionSetup();
            this.dropdownForPopupGroup = data;
            this.selectBoxForPopupExecutionSetup();
            this.isProcessing = false;
          })
        } else {
          this.appService.getQmsGroupsByModule(item.valueExp).subscribe((data: any) => {
            this.dropdownForGroup = data;
            this.selectBoxForGroup();
            this.dropdownForPopupGroup = data;
            this.selectBoxForPopupGroup();
            this.isProcessing = false;
          })
          this.appService.getQmsBusinessAreasByModule(item.valueExp).subscribe((data1: any) => {
            this.dropdownForBusinessArea = data1;
            this.selectBoxForBusinessArea();
            this.isProcessing = false;
          })
        }
      }
    }
  }

  responses: any[] = []; /* To store the responses sequentially */

  copy() {
    this.isProcessing = true;
    from(this.copyingFieldData)
      .pipe(
        concatMap((flexi: any, index: number) => {
          let specificBusinessArea = 'N';
          let businessAreasList = null;

          if (this.selectedTargetModuleValueExp !== 'AU' && this.selectedTargetModuleValueExp !== 'CC') {
            specificBusinessArea = flexi.APPLICABLE_FOR_SPECIFIC_BUSINESSAREA ? 'Y' : 'N';
            businessAreasList = flexi.ALLOWED_BUSINESSAREAS;
          }

          const field = {

            module: this.selectedTargetModuleValueExp,
            groupOrFolderIdList: this.selectedTargetModuleValueExp === 'DOCS' ? null : (this.selectedPopupGroup ?? null),
            fieldSeq: 1,
            fieldName: flexi.FIELD_NAME,
            instructions: flexi.INSTRUCTIONS,
            fieldType: flexi.FIELD_TYPE,
            fieldDatatype: flexi.FIELD_DATATYPE,
            fieldDateFormat: flexi.FIELD_DATE_FORMAT,
            fieldWidth: flexi.FIELD_WIDTH,
            fieldHeight: flexi.FIELD_HEIGHT,
            fieldDefaultValue: flexi.FIELD_DEFAULT_VALUE,
            fieldLovValues: flexi.FIELD_LOV_VALUES,
            fieldLovQuery: flexi.FIELD_LOV_QUERY,
            mappingColumn: flexi.MAPPING_COLUMN,
            isMandatory: flexi.IS_MANDATORY ? 'Y' : 'N',
            applicableForSpecificBusinessArea: specificBusinessArea,
            allowedBusinessAreas: businessAreasList,
            isActive: flexi.IS_ACTIVE ? 'Y' : 'N',
            appearFromStatus: null,
          };

          return this.appService.createFlexifieldSetup(field).pipe(
            tap((Response: any) => {
              this.responses[index] = { field, response: Response };
            }),
            concatMap(() => of(field))
          );
        })
      )
      .subscribe({
        next: (item) => {
          console.log('Processed an item:', item);
        },
        complete: () => {
          console.log('All API calls have been processed');
          console.log('Responses:', this.responses);
          this.isProcessing = false;
          this.visibleAddAndEditPopup.close();
          this.visibleCopyResultPopup = this.dialog.open(this.copyResultPopup, this.copyResultPopupConfig);
        },
        error: (error) => {
          this.isProcessing = false;
          console.error('Error occurred:', error);
        },
      });
  }

  cancelCopyResultPopup() {
    this.isCopyingFlexibleFields = false;
    this.getCall();
    this.visibleCopyResultPopup.close();
  }

  visibleReorderPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('reorderPopup', { static: true }) reorderPopup: TemplateRef<any>;


  reorderPopupConfig = {
    width: '700px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  title: any;
  redorderDataList: any = [];
  callReorderFunc() {
    this.title = "Reorder Flexifields";
    this.isProcessing = true;
    this.appService.getFlexifieldSetupByModuleList(
      this.selectedModule ?? null, this.selectedGroup?.toString() ?? null).subscribe((data: any) => {
        this.isProcessing = false;
        this.redorderDataList = data;
        for (let i = 0; i < this.redorderDataList.length; i++) {
          this.redorderDataList[i].newSeq = i + 1;
        }
        this.visibleReorderPopup = this.dialog.open(this.reorderPopup, this.reorderPopupConfig);
      })

  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.redorderDataList, event.previousIndex, event.currentIndex);
    for (let i = 0; i < this.redorderDataList.length; i++) {
      this.redorderDataList[i].newSeq = i + 1;
    }
  }

  reorderFunction() {
    this.isProcessing = true;
    for (let i = 0; i < this.redorderDataList.length; i++) {

      delete this.redorderDataList[i].createdOn;
      delete this.redorderDataList[i].updatedOn;

      this.redorderDataList[i].fieldSeq = this.redorderDataList[i]['newSeq'];
      this.appService.updateFlexifieldSetup(this.redorderDataList[i]).subscribe((data: any) => {
        if (i == this.redorderDataList.length - 1) {
          this.isProcessing = false;
          if (data.resultType == "S") {
            this.visibleReorderPopup.close();
            this.getCall();
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: data.result,
              type: data.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: data.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
        }
      })
    }
  }

  cancelReorderFunction() {
    this.visibleReorderPopup.close();
  }
}
